import { render, staticRenderFns } from "./question_content.vue?vue&type=template&id=d2580f6e&scoped=true&"
import script from "./question_content.vue?vue&type=script&lang=js&"
export * from "./question_content.vue?vue&type=script&lang=js&"
import style0 from "./question_content.vue?vue&type=style&index=0&id=d2580f6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2580f6e",
  null
  
)

export default component.exports